module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/picture_1-71d683bba710cfb5449a9a7547b62cd4.png";